import * as Yup from 'yup';

export const suportValidator = Yup.object().shape({
    name: Yup.string().required('Campo obrigatório'),
    phone: Yup.string().required('Campo obrigatório'),
    email: Yup.string().required('Campo obrigatório').email('Endereço de email inválido'),
    nameCampaign: Yup.string().required('Campo obrigatório'),
});
